import Select, { type MultiValue } from 'react-select';
import { type ContactDto } from '@/app/models/Contact';
import { useAudienceContacts } from '@/app/pages/notifications/announcements/core/_hooks';
import {
  contactLabel,
  selectedContacts,
  unlistedUserIds,
  userIdsOf,
} from '@/app/pages/notifications/announcements/core/_utils';

type AnnouncementUserSelectProps = {
  inputId: string;
  value: string[];
  disabled: boolean;
  onChange: (userIds: string[]) => void;
};

function AnnouncementUserSelect({ inputId, value, disabled, onChange }: AnnouncementUserSelectProps) {
  const { data, isPending } = useAudienceContacts();
  const contacts = data?.contacts ?? [];
  const isTruncated = data?.isTruncated ?? false;
  const shownUserCount = userIdsOf(contacts).length;
  const chosenContacts = selectedContacts(contacts, value);
  // Quem ficou fora da lista carregada não aparece no select, mas continua no público ao mudar a seleção.
  const keptUserIds = unlistedUserIds(contacts, value);

  const changeContacts = (nextContacts: MultiValue<ContactDto>) => {
    const chosenUserIds = userIdsOf([...nextContacts]);
    onChange([...keptUserIds, ...chosenUserIds]);
  };

  return (
    <div>
      <div className="announcement-audience-select position-relative">
        <i aria-hidden="true" className="bi bi-search text-muted position-absolute pe-none" />
        <Select<ContactDto, true>
          isMulti
          className="react-select-styled"
          classNamePrefix="react-select"
          getOptionLabel={contactLabel}
          getOptionValue={(contact) => contact.id ?? ''}
          inputId={inputId}
          isDisabled={disabled}
          isLoading={isPending}
          noOptionsMessage={() => 'Nenhum usuário encontrado'}
          options={contacts}
          placeholder="Buscar usuários…"
          value={chosenContacts}
          onChange={changeContacts}
        />
      </div>
      {isTruncated ? (
        <div className="form-text">
          Mostrando os primeiros {shownUserCount} usuários; use Perfis para alcançar todos.
        </div>
      ) : null}
    </div>
  );
}

export default AnnouncementUserSelect;
